import { Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import PublicLayout from './components/layout/PublicLayout';
import DashboardLayout from './components/layout/DashboardLayout';

// Public pages
import Landing from './pages/Landing';
import About from './pages/About';
import Leadership from './pages/Leadership';
import Clubs from './pages/Clubs';
import Contact from './pages/Contact';
import StoryList from './pages/stories/StoryList';
import StoryDetail from './pages/stories/StoryDetail';
import NewsList from './pages/news/NewsList';
import NewsDetail from './pages/news/NewsDetail';
import ActivityList from './pages/activities/ActivityList';
import ActivityDetail from './pages/activities/ActivityDetail';
import EventList from './pages/events/EventList';
import EventDetail from './pages/events/EventDetail';
import CalendarPage from './pages/CalendarPage';
import MediaCenter from './pages/MediaCenter';
import PageView from './pages/PageView';
import NotFound from './pages/NotFound';
import Unauthorized from './pages/Unauthorized';

// Auth pages
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';

// Member area
import MemberOverview from './pages/member/MemberOverview';
import MyStories from './pages/member/MyStories';
import StoryForm from './pages/member/StoryForm';
import MyNews from './pages/member/MyNews';
import NewsForm from './pages/member/NewsForm';
import MyActivities from './pages/member/MyActivities';
import ActivityForm from './pages/member/ActivityForm';
import Profile from './pages/member/Profile';
import ChangePassword from './pages/member/ChangePassword';

// Admin area
import AdminDashboard from './pages/admin/AdminDashboard';
import ApprovalCenter from './pages/admin/ApprovalCenter';
import AdminStories from './pages/admin/AdminStories';
import AdminNews from './pages/admin/AdminNews';
import AdminEvents from './pages/admin/AdminEvents';
import AdminActivities from './pages/admin/AdminActivities';
import AdminEventRecaps from './pages/admin/AdminEventRecaps';
import AdminMembers from './pages/admin/AdminMembers';
import AdminBoardOrder from './pages/admin/AdminBoardOrder';
import PageMaker from './pages/admin/PageMaker';
import MenuManager from './pages/admin/MenuManager';
import AdminMedia from './pages/admin/AdminMedia';
import AdminFacebook from './pages/admin/AdminFacebook';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public site */}
        <Route element={<PublicLayout />}>
          <Route index element={<Landing />} />
          <Route path="about" element={<About />} />
          <Route path="leadership" element={<Leadership />} />
          <Route path="clubs" element={<Clubs />} />
          <Route path="contact" element={<Contact />} />
          <Route path="stories" element={<StoryList />} />
          <Route path="stories/:id" element={<StoryDetail />} />
          <Route path="news" element={<NewsList />} />
          <Route path="news/:slug" element={<NewsDetail />} />
          <Route path="activities" element={<ActivityList />} />
          <Route path="activities/:slug" element={<ActivityDetail />} />
          <Route path="events" element={<EventList />} />
          <Route path="events/:slug" element={<EventDetail />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="media" element={<MediaCenter />} />
          <Route path="pages/:slug" element={<PageView />} />
          <Route path="unauthorized" element={<Unauthorized />} />
        </Route>

        {/* Auth (no chrome) */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Member dashboard */}
        <Route
          path="/member"
          element={
            <ProtectedRoute roles={['member']}>
              <DashboardLayout variant="member" />
            </ProtectedRoute>
          }
        >
          <Route index element={<MemberOverview />} />
          <Route path="stories" element={<MyStories />} />
          <Route path="stories/new" element={<StoryForm />} />
          <Route path="stories/:id/edit" element={<StoryForm />} />
          <Route path="news" element={<MyNews />} />
          <Route path="news/new" element={<NewsForm />} />
          <Route path="news/:id/edit" element={<NewsForm />} />
          <Route path="activities" element={<MyActivities />} />
          <Route path="activities/new" element={<ActivityForm />} />
          <Route path="activities/:id/edit" element={<ActivityForm />} />
          <Route path="profile" element={<Profile />} />
          <Route path="password" element={<ChangePassword />} />
        </Route>

        {/* Admin dashboard */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute roles={['administrator']}>
              <DashboardLayout variant="admin" />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="approvals" element={<ApprovalCenter />} />
          <Route path="stories" element={<AdminStories />} />
          <Route path="news" element={<AdminNews />} />
          <Route path="events" element={<AdminEvents />} />
          <Route path="events/:slug/recaps" element={<AdminEventRecaps />} />
          <Route path="activities" element={<AdminActivities />} />
          <Route path="members" element={<AdminMembers />} />
          <Route path="members/board-order" element={<AdminBoardOrder />} />
          <Route path="pages" element={<PageMaker />} />
          <Route path="menus" element={<MenuManager />} />
          <Route path="media" element={<AdminMedia />} />
          <Route path="facebook" element={<AdminFacebook />} />
        </Route>

        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </>
  );
}
